import { Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { Form } from "../../../layout";
import { AppContext } from "../../../App";
import { API, actions, endpoints } from "../../../api/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";
import { useTranslation } from "react-i18next";

const AddEditFollowUpType = (props) => {
  const { setAlert, setShowForm, updData, setTypes } = props;
  const { FollowUpTypeMdl } = Model();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { branch, authUser } = useContext(AppContext);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(FollowUpTypeMdl);

  useEffect(() => {
    updData && setValues((x) => ({ ...x, ...updData }));
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : t("ValName");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          if (setTypes && res.result.id) {
            updData
              ? setTypes((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setTypes((x) => [res.result, ...x]);
          }
          setAlert({
            isOpen: true,
            type: "success",
            title: t("Success"),
            subTitle: `${t("FollowUpType")} ${
              updData ? t("Update") : t("Added")
            } ${t("Successfully")}.`,
          });
          setShowForm(false);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: t("Error"),
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        API(endpoints.FollowUpType + actions.Post).post(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      } else
        API(endpoints.FollowUpType + actions.Put).put(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper
          className="p-15"
          sx={{ maxWidth: "450px", backgroundColor: "var(--aliceblue-color)" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} className="tx-center p-20 mb-10 pt-30 w-100pr">
              <span className="fw-4 fs-22 tx-upp gray-color">
                {updData ? t("Update") : t("Add")} {t("FollowType")}
              </span>
              <div className="pos-relative d-flex j-center mt-5">
                <div className="border-bottom w-60" />
              </div>
            </Grid>

            <Grid item xs={12}>
              <Input
                label={t("Name")}
                name="name"
                value={values.name}
                error={errors.name}
                required={true}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12} md={6}>
              <Button
                variant="text"
                size="large"
                onClick={handleClose}
                fullWidth
              >
                {t("Cancel")}
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button loading={loading} size="large" type="submit" fullWidth>
                {t("Submit")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default AddEditFollowUpType;
